export default "__VITE_ASSET__J5Hy_YcI__"